module.exports = __webpack_public_path__ + "static/media/sparkle-large.85b38ba8.svg";